import React from 'react';
import Theme from './providers/Theme';
import { LocaleProvider } from './providers/LocaleProvider';

const deploymentConfPrefix = '__OOS_CONF__';
window[deploymentConfPrefix] = {};

export default ({ children }) => (
    <LocaleProvider modules={[]} config={{}}>
        <Theme>{children}</Theme>
    </LocaleProvider>
);
